import styled from 'styled-components'

export const WizardHeader = styled.div`
  padding: 1.5rem 4.3rem 3.2rem 4.3rem;
`
